export let Update = {
  ANDROIDstoreURL: "", // '#ec356f',
  IOSstoreURL: "",
};
